var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-pagination',{attrs:{"align":"center","total-rows":_vm.total,"per-page":_vm.perPage},on:{"change":_vm.onPageChange},model:{value:(_vm.myCurrentPage),callback:function ($$v) {_vm.myCurrentPage=$$v},expression:"myCurrentPage"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }